<template>
  <div class="finish-end-page">
    <div class="page-header">
      <h2 class="page-title">已完成案件管理</h2>
      <p class="page-desc">按时间与关键信息筛选已完成案件</p>
    </div>

    <div class="filter-container">
      <div class="filter-row">
        <div class="filter-item">
          <label class="filter-label">起始时间</label>
          <el-date-picker
            @change="sttime()"
            v-model="st_time"
            align="right"
            type="date"
            placeholder="选择起始日期"
            :picker-options="pickerOptions1"
            class="filter-date-picker"
          >
          </el-date-picker>
        </div>
        <div class="filter-item">
          <label class="filter-label">结束时间</label>
          <el-date-picker
            @change="entime()"
            v-model="en_time"
            align="right"
            type="date"
            placeholder="选择结束日期"
            :picker-options="pickerOptions1"
            class="filter-date-picker"
          >
          </el-date-picker>
        </div>
        <div class="filter-item">
          <label class="filter-label">保单号</label>
          <el-input
            class="filter-input"
            @change="sttime()"
            v-model="victimPolicyNo"
            placeholder="请输入保单号"
            clearable
          ></el-input>
        </div>
        <div class="filter-item">
          <label class="filter-label">被保险人</label>
          <el-input
            class="filter-input"
            @change="sttime()"
            v-model="victimUser"
            placeholder="请输入被保险人"
            clearable
          ></el-input>
        </div>
        <div class="filter-item">
          <label class="filter-label">证件信息</label>
          <el-input
            class="filter-input"
            @change="sttime()"
            v-model="victimNational"
            placeholder="请输入证件信息"
            clearable
          ></el-input>
        </div>
        <div class="filter-item filter-item--action">
          <label class="filter-label filter-label--placeholder">&nbsp;</label>
          <el-button type="primary" class="filter-btn" icon="el-icon-search" @click="filt()">查询</el-button>
        </div>
      </div>
    </div>

    <div class="table-card">
      <el-table
        class="finish-table"
        empty-text="暂无数据"
        :data="tableData"
        border
        stripe
        :header-cell-style="headerCellStyle"
      >
        <el-table-column prop="number" label="序号" min-width="50" align="center">
        </el-table-column>
        <el-table-column prop="casenumber" label="案件编号" min-width="90" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="address" label="发生地点" min-width="140" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="username" label="用户姓名" min-width="70" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="phone" label="用户手机号" min-width="100" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="papers" label="证件信息" min-width="110" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="sex" label="性别" min-width="50" align="center">
        </el-table-column>
        <el-table-column prop="time" label="出险时间" min-width="100" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="par" label="用户保险详情" min-width="100" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              v-show="scope.row.isshow"
              @click="toUrl(scope.row.insuranceUrl)"
            >保险详情</el-button>
            <span class="empty-text" v-show="!scope.row.isshow">无</span>
          </template>
        </el-table-column>
        <el-table-column prop="plan" label="当前进度" min-width="80" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="node" label="当前节点" min-width="80" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="get_time" label="回复时间" min-width="100" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="op" label="操作" min-width="100" align="center" fixed="right">
          <template slot-scope="scope">
            <template v-if="scope.row.caseState != 111">
              <el-button
                v-if="scope.row.incidentType != 600"
                type="text"
                size="small"
                @click="tores(scope.row.initialCaseId, 1)"
              >救援详情</el-button>
              <el-button
                v-else
                type="text"
                size="small"
                @click="tores(scope.row.initialCaseId, 2)"
              >救援详情</el-button>
            </template>
            <el-button
              v-else
              type="text"
              size="small"
              @click="tores(scope.row.initialCaseId, 2)"
            >救援详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-bar">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage4"
          :page-sizes="[10]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import "isomorphic-fetch";
import constants from '@/util/constants.js';
export default {
  data() {
    return {
      start:0,
        count:10,
        total:0,
        currentPage4: 1,
        victimUser:'',
        victimPolicyNo:'',
        victimNational:'',
      tableData: [],
      token:JSON.parse(window.localStorage.getItem("data")).data,
      shortcuts: [
        {
          text: "今天",
          onClick(picker) {
            picker.$emit("pick", new Date());
          }
        },
        {
          text: "昨天",
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit("pick", date);
          }
        },
        {
          text: "一周前",
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", date);
          }
        }
      ],
      st_time: "",
      en_time: "",
      usertype: JSON.parse(window.localStorage.getItem("usertype")).data,
      parArray:["FinishPar","ComFinishPar","RegFinishPar2"],
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      headerCellStyle: {
        background: '#f5f7fb',
        color: '#303133',
        fontWeight: '600',
        fontSize: '13px'
      }
    };
  },
  methods: {
    handleSizeChange(val) {
         this.count = val
             this.getData()
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        this.start = (val-1) * this.count;
        // this.start = val * 10
            this.getData()
        console.log(`当前页: ${val}`);
      },
    tores(id,index) {
      if(index == 1){

        this.$router.push({
          path: '/cmd_center/caseDetails',
          query: {
            caseid: id
          },
        });
        return
        this.$router.push({
          name:'finishDetails',
          query:{
            caseid: id
          }
        });
      }else{
        this.$router.push({
          name:'finishDetails1',
          query:{
            caseid: id
          }
        });
      }

    },
    sttime() {
      this.st_time = this.st_time * 1;
      // this.getData(this.st_time, 0);
      // console.log(this.st_time);
    },
    entime() {
      this.en_time = this.en_time * 1;
      // this.getData(0, this.en_time);
    },
    filt() {
      this.getData(this.st_time, this.en_time);
      // this.getData(this.st_time, this.en_time + 86400000);
    },
    toUrl(url) {
    window.open(url);
    },
    getData(st, et) {
      this.tableData = [];
      let that = this;
      let n = 0;
      let sex = "";
      let isshow = false;
      let stTime = st || this.st_time;
      let enTime = et || this.en_time;
      let tl='';
      if (stTime && enTime) {
        tl=tl+`&startTs=${stTime}&endTs=${enTime}`;
      }
      var body='';
      if(this.$route.query.typeId != undefined){
      	body=`token=${this.token}&typeId=${this.$route.query.typeId}&status=110&status=111&status=113&victimUser=${this.victimUser}&victimPolicyNo=${this.victimPolicyNo}&victimNational=${this.victimNational}&start=${this.start}&count=${this.count}`+tl
      }else{
      	body=`token=${this.token}&status=110&status=111&status=113&victimUser=${this.victimUser}&victimPolicyNo=${this.victimPolicyNo}&victimNational=${this.victimNational}&start=${this.start}&count=${this.count}`+tl
      }

      fetch(constants.domain+"rescue/case/list_closed_case", {
          method: "POST",
          body,
          mode: "cors",
          headers: { "Content-Type": "application/x-www-form-urlencoded" }
        })
          .then(function(res) {
            return res.json();
          })
          .then(function(data) {
            if (data.obj) {
              that.total = data.total
              var plan = "";
              data.obj.map(v => {
                n = n + 1;
				if(v.victimList.length != 0){
					if (v.victimList[0].obj.gender == "1") {
					  sex = "男";
					} else {
					  sex = "女";
					}
					if (
					  v.victimList[0].obj.insurancePolicyNo &&
					  v.victimList[0].obj.insurancePolicyNo != ""
					) {
					  isshow = true;
					} else {
					  isshow = false;
					}

					var phone = v.victimList[0].obj.victimName;
					var username = v.victimList[0].obj.victimName;
				}
var pt=constants.pt2txt(v.obj.caseState);
//              if(that.usertype == 0){
//                username = constants.strHidden(v.victimList[0].obj.victimName,1); //姓名
//                phone = constants.strHidden(v.obj.reporterContact); //联系方式
//              }
								var address='';
								if(v.generalLocation){

									if(!constants.setTxt(v.generalLocation.addr,'zh')){
										address=v.generalLocation.addr
									}else{
										address=constants.setTxt(v.generalLocation.addr,'zh')
									}
								}
                that.tableData.push({
                  caseState:v.obj.caseState,
                  caseid: v.obj.id,
                  initialCaseId: v.obj.initialCaseId,
                  incidentType:v.obj.incidentType,
                  number: n, //序号
                  casenumber: v.obj.caseNo, //案件编号
                  address, //地址
                  username: username, //姓名
                  phone: phone, //联系方式
                  papers:v.victimList.length != 0? v.victimList[0].obj.idNo:"无", //身份证号
                  sex: sex, //性别
                  time: constants.time(v.obj.incidentTs), //出险时间
                  isshow: isshow, //保单
                  plan: pt.phase, //进度
                  node: pt.node, //节点
                  get_time: constants.time(v.rInstiFeedbackTs),
                  op: "查看并操作",
                  insuranceUrl:v.victimList.length != 0?v.victimList[0].obj.insurancePaper :'', //用户保险详情链接
                });
                that.caseid = v.obj.id;
                // console.log(that.obj)
                // that.obj.push(v.obj);
                // that.victimList.push(v.victimList[0]);
              });
            }
          });
    },

  },
  mounted() {
    this.getData();
  },
};
</script>

<style scoped>
.finish-end-page {
  padding: 4px 4px 24px;
  box-sizing: border-box;
}

.page-header {
  margin-bottom: 16px;
}

.page-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  line-height: 1.4;
}

.page-desc {
  margin: 6px 0 0;
  font-size: 13px;
  color: #909399;
  line-height: 1.4;
}

.filter-container {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 16px;
  border: 1px solid #ebeef5;
}

.filter-row {
  display: flex;
  flex-wrap: nowrap;
  gap: 12px 16px;
  align-items: flex-end;
}

.filter-item {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1 1 0;
}

.filter-item--action {
  flex: 0 0 auto;
  min-width: auto;
}

.filter-label {
  font-size: 13px;
  color: #606266;
  margin-bottom: 8px;
  font-weight: 500;
  white-space: nowrap;
}

.filter-label--placeholder {
  visibility: hidden;
}

.filter-date-picker,
.filter-input {
  width: 100% !important;
}

.filter-date-picker >>> .el-date-editor.el-input,
.filter-date-picker >>> .el-date-editor.el-input__inner,
.filter-date-picker >>> .el-input {
  width: 100% !important;
}

.filter-btn {
  min-width: 88px;
  padding: 10px 18px;
  border-radius: 4px;
}

.table-card {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 12px 12px 8px;
  overflow: hidden;
}

.finish-table {
  width: 100%;
}

.finish-table >>> .el-table__header th {
  padding: 10px 0;
}

.finish-table >>> .el-table__body td {
  padding: 10px 0;
}

.finish-table >>> .el-button--text {
  color: #409eff;
  padding: 0 4px;
}

.finish-table >>> .el-button--text:hover {
  color: #66b1ff;
}

.empty-text {
  color: #c0c4cc;
  font-size: 13px;
}

.pagination-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 16px;
  padding: 4px 4px 8px;
  clear: both;
}

@media (max-width: 1200px) {
  .filter-row {
    flex-wrap: wrap;
  }

  .filter-item {
    flex: 1 1 calc(33.33% - 12px);
    min-width: 160px;
  }

  .filter-item--action {
    flex: 0 0 auto;
  }
}

@media (max-width: 768px) {
  .filter-item {
    flex: 1 1 100%;
  }

  .filter-item--action,
  .filter-btn {
    width: 100%;
  }

  .pagination-bar {
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cmd_center/finish.vue